import { Component, Vue } from 'vue-property-decorator'
import { Action, Getter, Mutation } from 'vuex-class'

import ApiRequest from '@/core/ApiRequest'
import AccessModel from '@/core/models/AccessModel'
import { MenuItem, MenuGroup } from '@/core/models/Menu'
import {
  GET_MENU_LIST,
  GET_ACCESS_MODEL,
  GET_API_REQUEST,
  IS_MENU_DIALOG_SHOWN,
} from '@/store/root/getters'
import { DELETE_MENU_ITEM, FETCH_MENU_LIST, SWAP_MENU_ITEMS } from '@/store/root/actions'
import { SET_MENU_DIALOG_SHOWN, SET_LOADING } from '@/store/root/mutations'
import MenuChangeDialog from './menu-change-dialog/MenuChangeDialog.vue'


@Component({
  components: { MenuChangeDialog }
})
export default class Menu extends Vue {
  public groups: MenuGroup[] = []
  public menuDialogMode = 'add'
  public menuDialogItem: MenuItem | null = null

  /**
   * Get api request object, based on global Vuex state.
   */
  @Getter(GET_API_REQUEST)
  public getApiRequest: ApiRequest

  /**
   * Get access model, based on global Vuex state.
   */
  @Getter(GET_ACCESS_MODEL)
  public getAccessModel: AccessModel | null

  /**
   * Sets is loading flag state.
   */
  @Mutation(SET_LOADING)
  public setLoading: (isLoading: boolean) => void

  /**
   * Sets is menu dialog shown flag state.
   */
  @Mutation(SET_MENU_DIALOG_SHOWN)
  public setMenuDialogShown: (isMenuDialogShown: boolean) => void

  /**
   * Get is menu dialog shown flag, based on global Vuex state.
   */
  @Getter(IS_MENU_DIALOG_SHOWN)
  public isMenuDialogShown: boolean

  /**
   * Fetch menu list.
   */
  @Action(FETCH_MENU_LIST)
  public fetchMenuList: () => void;

  /**
   * Fetch menu list.
   */
  @Action(DELETE_MENU_ITEM)
  public deleteMenuItem: (item: MenuItem) => void;

  /**
   * Swap menu items in menu list.
   */
  @Action(SWAP_MENU_ITEMS)
  public swapMenuItem: (payload: {item1: MenuItem, item2: MenuItem}) => void;

  /**
   * Get menu list, based on global Vuex state.
   */
  @Getter(GET_MENU_LIST)
  public getMenuList: MenuGroup[]

  /**
   * Move menu item to up.
   */
  public async moveItem (item1: MenuItem, up: boolean = true) {
    const group = this.groups.find((group) => (group.id === item1.groupId))
    if (!group) { return }

    const id1Index = group.items.findIndex((item) => (item.id === item1.id))
    if (id1Index < 0) { return }

    const id2Index = up ? id1Index - 1 : id1Index + 1
    if (id2Index < 0 || id2Index >= group.items.length) { return }
    const item2 = group.items[id2Index]

    this.swapMenuItem({ item1, item2 })
  }

  /**
   * Show add menu item dialog.
   */
  public addItem () {
    this.menuDialogMode = 'add'
    this.menuDialogItem = null
    this.setMenuDialogShown(true)
  }

  /**
   * Show change menu item dialog.
   */
  public changeUser (item: MenuItem) {
    this.menuDialogMode = 'change'
    this.menuDialogItem = item
    this.setMenuDialogShown(true)
  }

  /**
   * Delete menu item.
   */
  public async deleteItem (item: MenuItem) {
    console.log(`deleteItem(${item.id})`)
    if (await this.$confirm(`Удалить '${item.title}' ?`)) {
      await this.deleteMenuItem(item)
      await this.fetchMenuList()
    }
  }

  /**
   * Created lifecycle hook. Fires when component instance is created.
   */
  public async created () {
    if (!this.getAccessModel || !this.getAccessModel.user) {
      return
    }
    await this.fetchMenuList()
    this.groups = this.getMenuList
  }
}
